import React from 'react';
import styles from './Footer.module.css';
import SocialIcons from './SocialIcons';
import logo from '../assets/crop_transparent_dark.svg';

const Footer: React.FC = () => {
  return (
    <footer className={styles.mainFooter}>
      <div className={styles.footerContent}>
        <img src={logo} alt="LB Tiling Company Logo" className={styles.logo} />
        <div className={styles.copyright}>
          <p>&copy; {new Date().getFullYear()} LB Tiling Company</p>
          <p>All rights reserved</p>
        </div>
        <div className={styles.footerSocial}>
          <SocialIcons fontSize="1.1rem" hoverColor="#e8e9eb" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;